{
  "defaultLockedAccount": {
    "electronicFundsTransferInMessage": "Impossible d'initier un dépôt bancaire à partir d'un compte de revenus.",
    "electronicFundsTransferOutMessage": "Impossible d'initier un retrait direct à partir d'un compte de revenus enregistré.",
    "internalTransferToMessage": "Veuillez communiquer avec l'assistance pour faciliter le virement des fonds"
  },
  "LIRA": {
    "electronicFundsTransferInMessage": "Impossible d'initier un dépôt bancaire à partir d'un compte immobilisé.",
    "electronicFundsTransferOutMessage": "Veuillez communiquer avec l'assistance pour faciliter le virement des fonds",
    "internalTransferToMessage": "Veuillez communiquer avec l'assistance pour faciliter le virement des fonds"
  },
  "LRSP": {
    "electronicFundsTransferInMessage": "Impossible d'initier un dépôt bancaire à partir d'un compte immobilisé.",
    "electronicFundsTransferOutMessage": "Veuillez communiquer avec l'assistance pour faciliter le virement des fonds",
    "internalTransferToMessage": "Veuillez communiquer avec l'assistance pour faciliter le virement des fonds"
  },
  "RLSP": {
    "electronicFundsTransferInMessage": "Impossible d'initier un dépôt bancaire à partir d'un compte immobilisé.",
    "electronicFundsTransferOutMessage": "Veuillez communiquer avec l'assistance pour faciliter le virement des fonds",
    "internalTransferToMessage": "Veuillez communiquer avec l'assistance pour faciliter le virement des fonds"
  },
  "RRSP": {
    "electronicFundsTransferOutMessage": "Les virements REER sont généralement un virement vers un autre compte REER, un retrait d'un plan d'accession à la propriété ou un virement vers un FEER. Veuillez communiquer avec l'assistance pour faciliter le virement des fonds."
  },
  "RRSP_SPOUSAL": {
    "electronicFundsTransferOutMessage": "Les virements REER sont généralement un virement vers un autre compte REER, un retrait d'un plan d'accession à la propriété ou un virement vers un FEER. Veuillez communiquer avec l'assistance pour faciliter le virement des fonds."
  }
}
